import { AppKeyEnum, PlatformEnum } from '@/constants/enum';
import { cmsApiCaller } from '@/redux/query/cms-admin';
import { Banner, Columns, Text } from '@shopify/polaris';
import { useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'hide_holiday_banner';

const HolidayBanner = () => {
  const [isHide, setIsHide] = useState<Record<string, boolean>>(JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'));

  useEffect(() => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(isHide));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(isHide)]);

  const { data } = cmsApiCaller.useGetHolidayBannerQuery({
    appKey: AppKeyEnum.PaypalTracking,
    platform: PlatformEnum.Wix,
    languageCode: 'en',
  });

  const banners = useMemo(() => {
    const banners = data?.data || [];
    return banners
      .map((banner) => {
        if (!banner.isActive) return undefined;
        const { bannerTranslations, ...rest } = banner;

        const activeTranslations = bannerTranslations.filter((t) => t.isActive);
        const translation = activeTranslations.find((t) => t.languageCode === 'en') || activeTranslations[0];

        if (!translation) return undefined;

        return {
          ...rest,
          title: translation.title,
          description: translation.description,
        };
      })
      .filter((banner) => !!banner)
      .sort((a, b) => (a?.priority || 0) - (b?.priority || 0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(data)]);

  const handleHideBanner = (key: string) => {
    setIsHide((prev) => ({ ...prev, [key]: true }));
  };

  return (
    <div className="mt-16">
      <Columns>
        {banners.map((banner) =>
          !isHide[banner?.bannerKey || ''] ? (
            <Banner
              key={banner?.id}
              title={banner?.title}
              onDismiss={banner?.isShowDismissBtn ? () => handleHideBanner(banner?.bannerKey || '') : undefined}
              status={banner?.tone || 'info'}
            >
              {banner?.description.map((description) => (
                <Text as="h5" variant="bodyMd" key={description}>
                  {description}
                </Text>
              ))}
            </Banner>
          ) : null,
        )}
      </Columns>
    </div>
  );
};

export default HolidayBanner;
